import { useMemo } from "react";
import useFeature from "../../Shared/FeatureProvider/useFeature";
import { useDeviceMediaQuery } from "../../Shared/UseDeviceMediaQuery/useDeviceMediaQuery";

const useCanAccessHelp = () => {
      const {isEnabled} = useFeature();
      const {isMobile} = useDeviceMediaQuery()
      return useMemo(() => !isMobile && isEnabled('help'), [isEnabled,isMobile]);
};
  
export default useCanAccessHelp;